import { render, staticRenderFns } from "./DispensaUnidade.vue?vue&type=template&id=674e3096"
import script from "./DispensaUnidade.vue?vue&type=script&lang=js"
export * from "./DispensaUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports